import {action, observable, runInAction} from 'mobx';
import { ResizeObserver } from '@juggle/resize-observer';

import {ServiceBase} from '../ServiceBase';
import {IHeaderService} from './header.service.interface';
import {IServiceFactoryExtended} from '../service-factory-extended.interface';


export class HeaderService extends ServiceBase implements IHeaderService {

    private _headerResizeObserver: ResizeObserver = null;
    private _headerRegulationDataResizeObserver: ResizeObserver = null;

    @observable.ref private _headerElement: HTMLElement | null = null;
    @observable.ref private _headerRegulationDataElement: HTMLElement | null = null;

    @observable headerHeight: number  = 0;
    @observable headerRegulationDataHeight: number = 0;

    constructor(services: IServiceFactoryExtended) {
        super(services);

        this._headerResizeObserver = new ResizeObserver(this._onHeaderResize);
        this._headerRegulationDataResizeObserver = new ResizeObserver(this._onHeaderRegulationDataResize);

        this.reaction(() => this._headerElement, (element) => {
            this.headerHeight = element?.offsetHeight || 0;
            if(element){
                this._headerResizeObserver.observe(element);
            }
        });

        this.reaction(() => this._headerRegulationDataElement, (element) => {
            this.headerRegulationDataHeight = element?.offsetHeight || 0;
            if(element){
                this._headerRegulationDataResizeObserver.observe(element);
            }
        });
    }

    @action.bound
    private _onHeaderResize = () => {
        if (this._headerElement) {
            this.headerHeight = this._headerElement.offsetHeight;
        }
    };

    @action.bound
    private _onHeaderRegulationDataResize = () => {
        if (this._headerRegulationDataElement) {
            this.headerRegulationDataHeight = this._headerRegulationDataElement.offsetHeight;
        }
    };

    setHeaderElement(headerElement: HTMLElement): void {
        if(this._headerElement) {
            this._headerResizeObserver.disconnect();
        }

        runInAction(() => {
            this._headerElement = headerElement;
        });
    }

    setHeaderRegulationDataElement(headerRegulationDataElement: HTMLElement): void {
        if(this._headerRegulationDataElement) {
            this._headerRegulationDataResizeObserver.disconnect();
        }

        runInAction(() => {
            this._headerRegulationDataElement = headerRegulationDataElement;
        });
    }

    getHeaderRegulationDataElement(): HTMLElement | null {
        return this._headerRegulationDataElement;
    }

    getHeaderElement(): HTMLElement | null {
        return this._headerElement;
    }

}
